module.exports = __webpack_public_path__ + "img/dinersClub.d2ed4e31.png";